export class NaviosModel {
  id: number;
  nome: string;
}



// WEBPACK FOOTER //
// ./src/app/navios/navios.model.ts